import type { ListSettings, Pagination } from '@common/types'
import { ListViews } from '@common/types'
import type { SearchVariables } from '@hooks/makeSearch'

export const DEFAULT_NOTIFICATION_SHOW_TIME = 3000

export const PAGINATE_BY = 20

export const DEFAULT_INITIAL_SEARCH_DATA: SearchVariables = {
  after: undefined,
  first: PAGINATE_BY,
}

export const DEFAULT_INITIAL_PAGINATION_DATA: Pagination = {
  after: undefined,
  before: undefined,
}

export interface AppListViewSettings {
  [ListViews.APP_LIST]: ListSettings
  [ListViews.BUSINESS_ENTITY_LIST]: ListSettings
  [ListViews.CASE_LIST_ALL]: ListSettings
  [ListViews.CASE_LIST_USER_ASSIGNED]: ListSettings
  [ListViews.CASE_LIST_TEAM_ASSIGNED]: ListSettings
  [ListViews.CASE_SETTINGS_LIST]: ListSettings
  [ListViews.CUSTOMER_LIST]: ListSettings
  [ListViews.FINANCIAL_PROVIDER_LIST]: ListSettings
  [ListViews.TICKET_LIST_USER_ASSIGNED]: ListSettings
  [ListViews.TICKET_LIST_TEAM_ASSIGNED]: ListSettings
  [ListViews.TICKET_LIST_ALL]: ListSettings
  [ListViews.USER_LIST]: ListSettings
  [ListViews.USER_TEAM_LIST]: ListSettings
}

export const defaultListSettings: AppListViewSettings = {
  [ListViews.APP_LIST]: {
    rowNumber: PAGINATE_BY,
  },
  [ListViews.BUSINESS_ENTITY_LIST]: {
    rowNumber: PAGINATE_BY,
  },
  [ListViews.CASE_LIST_ALL]: {
    columns: ['code', 'type', 'customer', 'customerCode', 'status', 'assignee', 'createdAt'],
    rowNumber: PAGINATE_BY,
  },
  [ListViews.CASE_LIST_USER_ASSIGNED]: {
    columns: ['code', 'customer', 'customerCode', 'status', 'createdAt'],
    rowNumber: PAGINATE_BY,
  },
  [ListViews.CASE_LIST_TEAM_ASSIGNED]: {
    columns: ['code', 'customer', 'customerCode', 'status', 'assignee', 'createdAt'],
    rowNumber: PAGINATE_BY,
  },
  [ListViews.CASE_SETTINGS_LIST]: {
    rowNumber: PAGINATE_BY,
  },
  [ListViews.CUSTOMER_LIST]: {
    rowNumber: PAGINATE_BY,
  },
  [ListViews.FINANCIAL_PROVIDER_LIST]: {
    rowNumber: PAGINATE_BY,
  },
  [ListViews.TICKET_LIST_USER_ASSIGNED]: {
    columns: ['code', 'financialProvider', 'providerContact', 'status', 'tags', 'createdAt'],
    rowNumber: PAGINATE_BY,
  },
  [ListViews.TICKET_LIST_TEAM_ASSIGNED]: {
    columns: [
      'code',
      'financialProvider',
      'type',
      'providerContact',
      'status',
      'assignee',
      'tags',
      'createdAt',
    ],
    rowNumber: PAGINATE_BY,
  },
  [ListViews.TICKET_LIST_ALL]: {
    columns: ['code', 'financialProvider', 'type', 'status', 'assigneeTeam', 'tags', 'createdAt'],
    rowNumber: PAGINATE_BY,
  },
  [ListViews.USER_LIST]: {
    rowNumber: PAGINATE_BY,
  },
  [ListViews.USER_TEAM_LIST]: {
    rowNumber: PAGINATE_BY,
  },
}
